export default __webpack_public_path__ + "static/media/brand-logo.929b91a6.webp";